import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import _ from 'underscore';
import moment from 'moment';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import history from '../../config/history';
import formatDate from '../../services/formatDate';
import mixpanelConstants from '../../constants/mixpanel';
import { HTTPStatusCodes } from '../../constants/httpStatusCodes';

export const initializeNewShift = createAction('INITIALIZE_SHIFT');
export const resetShift = createAction('REST_SHIFT');
export const setShiftLocationID = createAction('SET_SHIFT_LOCATION_ID');
export const setLocDepartmentList = createAction('SET_SHIFT_DEPARTMENT_LIST');
export const setShiftDepartmentID = createAction('SET_SHIFT_DEPARTMENT_ID');
export const setShiftStartDate = createAction('SET_SHIFT_START_DATE');
export const setShiftEndDate = createAction('SET_SHIFT_END_DATE');
export const setShiftTimeList = createAction('SET_SHIFT_TIME_LIST');
export const setClinicianPools = createAction('SET_CLINICIAN_POOLS');
export const setPreferredPools = createAction('SET_PREFERRED_POOLS');
export const setShiftNote = createAction('SET_SHIFT_NOTE');
export const setCustomShiftStartAt = createAction('SET_CUSTOM_SHIFT_START_AT');
export const setCustomShiftPeriod = createAction('SET_CUSTOM_SHIFT_PERIOD');
export const setCustomShiftDuration = createAction('SET_CUSTOM_SHIFT_DURATION');
export const setShiftOpenPositions = createAction('SET_SHIFT_OPEN_POSITIONS');
export const setPartTimeNotifyAfter = createAction('SET_SHIFT_PARTTIME_NOTIFY_AFTER');
export const setFullTimeNotifyAfter = createAction('SET_SHIFT_FULLTIME_NOTIFY_AFTER');
export const setExternalNotifyAfter = createAction('SET_SHIFT_EXTERNAL_NOTIFY_AFTER');
export const setPartTimeNotifyAfterHr = createAction('SET_SHIFT_PARTTIME_NOTIFY_AFTER_HR');
export const setFullTimeNotifyAfterHr = createAction('SET_SHIFT_FULLTIME_NOTIFY_AFTER_HR');
export const setExternalNotifyAfterHr = createAction('SET_SHIFT_EXTERNAL_NOTIFY_AFTER_HR');
export const setShiftTime = createAction('SET_SHIFT_TIME');
export const setShiftRoles = createAction('SET_SHIFT_ROLES');
export const setShiftRecurring = createAction('SET_SHIFT_RECURRING');
export const setShiftPost = createAction('SET_SHIFT_POST_STATUS');
export const setShiftOrganizationID = createAction('SET_SHIFT_ORGANIZATION_ID');
export const setIsFrom = createAction('SET_IS_FROM');

export const setCustomShiftStartTime = createAction('SET_CUSTOM_SHIFT_START_TIME');
export const setCustomShiftEndTime = createAction('SET_CUSTOM_SHIFT_END_TIME');
export const setIsFetchingUserOrgData = createAction('SET_IS_FETCHING_USER_ORG_DATA');

export const setIsForbiddenToCreateShift = createAction('SET_IS_FORBIDDEN_TO_CREATE_SHIFT');
export const setForbiddenMessage = createAction('SET_FORBIDDEN_MESSAGE');

export const setIsSuccessful = createAction('SHIFTS/SET_SUCCESSFUL');
export const setIsSubmittingShift = createAction('SHIFTS/SET_IS_SUBMITTING');

export const setMultipleDates = createAction('SHIFTS/SET_MULTIPLE_DATES');

export const setPRNPoolEnabled = createAction('SHIFTS/SET_PRN_POOL_ENABLED');
export const setPRNPoolDays = createAction('SHIFTS/SET_PRN_POOL_DAYS');

export const setHasCovidPatients = createAction('SHIFTS/SET_HAS_COVID_PATIENTS');
export const setCovidContactFlag = createAction('SHIFTS/SET_COVID_CONTACT_FLAG');

export const setSelectedShiftTimeList = createAction('SHIFTS/SET_SELECTED_SHIFT_TIMELIST');
export const setBonusAmount = createAction('SET_BONUS_AMOUNT');
export const setBonusUnit = createAction('SET_BONUS_UNIT');

const initialState = {
	bonusAmount: null,
	bonusUnit: null,
	clinicianPools: [],
	covidContactFlag: false,
	customShiftDuration: '',
	customShiftEndTime: null,
	customShiftPeriod: 'AM',
	customShiftStartAt: '',
	customShiftStartTime: null,
	dates: [],
	departmentID: 0,
	externalNotifyAfterHr: '',
	forbiddenMessage: '',
	fullTimeNotifyAfterHr: '',
	hasCovidPatients: false,
	is_externalNotifyAfter: true,
	is_fullTimeNotifyAfter: true,
	is_partTimeNotifyAfter: true,
	is_recurring: 0,
	isFetchingUserOrgData: true,
	isForbiddenToCreateShift: false,
	isFrom: '',
	isSubmitting: false,
	isSuccessful: null,
	locationID: 0,
	locDepartmentList: [],
	nurseRole: [],
	openPositions: '1',
	organizationID: '',
	partTimeNotifyAfterHr: '',
	preferredPools: [],
	prnPoolDays: '',
	prnPoolEnabled: null,
	readyToPost: false,
	selectedShiftTimeList: [],
	shiftEndDate: '',
	shiftNote: '',
	shiftRoles: [],
	shiftStartDate: '',
	shiftTimeID: '',
	shiftTimeList: []
};

const INITIAL_VALUES = {
	bonusAmount: null,
	bonusUnit: null,
	clinicianPools: [],
	covidContactFlag: false,
	customShiftDuration: '',
	customShiftEndTime: null,
	customShiftPeriod: 'AM',
	customShiftStartAt: '',
	customShiftStartTime: null,
	dates: [],
	departmentID: 0,
	externalNotifyAfterHr: '',
	forbiddenMessage: '',
	fullTimeNotifyAfterHr: '',
	hasCovidPatients: false,
	is_externalNotifyAfter: true,
	is_fullTimeNotifyAfter: true,
	is_partTimeNotifyAfter: true,
	is_recurring: 0,
	isForbiddenToCreateShift: false,
	isFrom: '',
	locationID: 0,
	nurseRole: [],
	openPositions: '1',
	partTimeNotifyAfterHr: '',
	preferredPools: [],
	prnPoolDays: '',
	prnPoolEnabled: null,
	selectedShiftTimeList: [],
	shiftEndDate: '',
	shiftNote: '',
	shiftRoles: [],
	shiftStartDate: '',
	shiftTimeID: ''
};

export default handleActions(
	{
		INITIALIZE_SHIFT: (state) => ({ ...state, ...INITIAL_VALUES }),
		REST_SHIFT: () => initialState,
		SET_BONUS_AMOUNT: (state, action) => ({ ...state, bonusAmount: action.payload }),
		SET_BONUS_UNIT: (state, action) => ({ ...state, bonusUnit: action.payload }),
		SET_CLINICIAN_POOLS: (state, action) => ({ ...state, clinicianPools: action.payload }),
		SET_CUSTOM_SHIFT_DURATION: (state, action) => ({ ...state, customShiftDuration: action.payload }),
		SET_CUSTOM_SHIFT_END_TIME: (state, action) => ({ ...state, customShiftEndTime: action.payload }),
		SET_CUSTOM_SHIFT_PERIOD: (state, action) => ({ ...state, customShiftPeriod: action.payload }),
		SET_CUSTOM_SHIFT_START_AT: (state, action) => ({ ...state, customShiftStartAt: action.payload }),
		SET_CUSTOM_SHIFT_START_TIME: (state, action) => ({ ...state, customShiftStartTime: action.payload }),
		SET_FORBIDDEN_MESSAGE: (state, action) => ({ ...state, forbiddenMessage: action.payload }),
		SET_IS_FETCHING_USER_ORG_DATA: (state, action) => ({ ...state, isFetchingUserOrgData: action.payload }),
		SET_IS_FORBIDDEN_TO_CREATE_SHIFT: (state, action) => ({ ...state, isForbiddenToCreateShift: action.payload }),
		SET_IS_FROM: (state, action) => ({ ...state, isFrom: action.payload }),
		SET_PREFERRED_POOLS: (state, action) => ({ ...state, preferredPools: action.payload }),
		SET_SHIFT_DEPARTMENT_ID: (state, action) => ({ ...state, departmentID: action.payload }),
		SET_SHIFT_DEPARTMENT_LIST: (state, action) => ({ ...state, locDepartmentList: action.payload }),
		SET_SHIFT_END_DATE: (state, action) => ({ ...state, shiftEndDate: action.payload }),
		SET_SHIFT_EXTERNAL_NOTIFY_AFTER: (state, action) => ({ ...state, is_externalNotifyAfter: action.payload }),
		SET_SHIFT_EXTERNAL_NOTIFY_AFTER_HR: (state, action) => ({ ...state, externalNotifyAfterHr: action.payload }),
		SET_SHIFT_FULLTIME_NOTIFY_AFTER: (state, action) => ({ ...state, is_fullTimeNotifyAfter: action.payload }),
		SET_SHIFT_FULLTIME_NOTIFY_AFTER_HR: (state, action) => ({ ...state, fullTimeNotifyAfterHr: action.payload }),
		SET_SHIFT_LOCATION_ID: (state, action) => ({ ...state, locationID: action.payload }),
		SET_SHIFT_NOTE: (state, action) => ({ ...state, shiftNote: action.payload }),
		SET_SHIFT_OPEN_POSITIONS: (state, action) => ({ ...state, openPositions: action.payload }),
		SET_SHIFT_ORGANIZATION_ID: (state, action) => ({ ...state, organizationID: action.payload }),
		SET_SHIFT_PARTTIME_NOTIFY_AFTER: (state, action) => ({ ...state, is_partTimeNotifyAfter: action.payload }),
		SET_SHIFT_PARTTIME_NOTIFY_AFTER_HR: (state, action) => ({ ...state, partTimeNotifyAfterHr: action.payload }),
		SET_SHIFT_POST_STATUS: (state, action) => ({ ...state, readyToPost: action.payload }),
		SET_SHIFT_RECURRING: (state, action) => ({ ...state, is_recurring: action.payload }),
		SET_SHIFT_ROLES: (state, action) => ({ ...state, shiftRoles: action.payload }),
		SET_SHIFT_START_DATE: (state, action) => ({ ...state, shiftStartDate: action.payload }),
		SET_SHIFT_TIME: (state, action) => ({ ...state, shiftTimeID: action.payload }),
		SET_SHIFT_TIME_LIST: (state, action) => ({ ...state, shiftTimeList: action.payload }),
		'SHIFTS/SET_COVID_CONTACT_FLAG': (state, action) => ({ ...state, covidContactFlag: action.payload }),
		'SHIFTS/SET_HAS_COVID_PATIENTS': (state, action) => ({ ...state, hasCovidPatients: action.payload }),
		'SHIFTS/SET_IS_SUBMITTING': (state, action) => ({ ...state, isSubmitting: action.payload }),
		'SHIFTS/SET_MULTIPLE_DATES': (state, action) => ({ ...state, dates: action.payload }),
		'SHIFTS/SET_PRN_POOL_DAYS': (state, action) => ({ ...state, prnPoolDays: action.payload }),
		'SHIFTS/SET_PRN_POOL_ENABLED': (state, action) => ({ ...state, prnPoolEnabled: action.payload }),
		'SHIFTS/SET_SELECTED_SHIFT_TIMELIST': (state, action) => ({
			...state,
			selectedShiftTimeList: action.payload
		}),
		'SHIFTS/SET_SUCCESSFUL': (state, action) => ({ ...state, isSuccessful: action.payload })
	},
	initialState
);

export const getOrganizationShiftTimes = (id) =>
	function (dispatch) {
		Agent.getOrgShiftTimes(id).then((response) => {
			if (response.ok) {
				dispatch(setShiftTimeList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

/* Fetch the shift times for particular location if not
   available api will respond with default shift times */
export const getLocationShiftTimes = (locationID, organizationID) =>
	function (dispatch) {
		Agent.getLocShiftTimes(locationID, organizationID).then((response) => {
			if (response.ok) {
				if (response.data.org_times?.length > 0) {
					dispatch(setShiftTimeList(response.data.org_times));
				} else {
					const locationShiftTimes = response.data.location_shift_times?.map((locationTime) => ({
						id: locationTime.location_shift_time_id,
						...locationTime
					}));
					dispatch(setShiftTimeList(locationShiftTimes));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getClinicianPools = () => async (dispatch) => {
	const response = await Agent.getClinicianPools();
	if (response.ok) {
		dispatch(setClinicianPools(response.data));
	} else {
		dispatch(handleError(response));
	}
	return response.data;
};
export const postNewShft = (cb) =>
	function (dispatch, getState) {
		let shift_start = '';
		let shift_end = '';
		let shift_start_date = getState().supervisorShift.shiftStartDate;
		let shift_end_date = getState().supervisorShift.shiftEndDate;
		const timeID = getState().supervisorShift.shiftTimeID;
		const timeList = getState().supervisorShift.shiftTimeList;

		const { customShiftStartTime } = getState().supervisorShift;
		const { customShiftEndTime } = getState().supervisorShift;

		if (timeID) {
			shift_start = _.where(timeList, { id: timeID })[0].start_time;
			shift_end = _.where(timeList, { id: timeID })[0].end_time;
		} else {
			shift_start = moment(customShiftStartTime).format('HH:mm:00');
			shift_end = moment(customShiftEndTime).format('HH:mm:00');
		}

		if (shift_start_date != '') {
			shift_start_date = formatDate.clientDateToYyMmDd(shift_start_date);
		}

		if (shift_end_date != '') {
			shift_end_date = formatDate.clientDateToYyMmDd(shift_end_date);
		}

		const shiftObj = {
			aft_delay: parseInt(getState().supervisorShift.fullTimeNotifyAfterHr),
			allow_external_nurses: getState().supervisorShift.is_externalNotifyAfter == true ? 'Y' : 'N',
			allow_full_time_nurses: getState().supervisorShift.is_fullTimeNotifyAfter == true ? 'Y' : 'N',
			allow_part_time_nurses: getState().supervisorShift.is_partTimeNotifyAfter == true ? 'Y' : 'N',
			aoa_delay: parseInt(getState().supervisorShift.externalNotifyAfterHr),
			apt_delay: parseInt(getState().supervisorShift.partTimeNotifyAfterHr),
			covid_contact_flag: getState().supervisorShift.covidContactFlag,
			dates: (getState().supervisorShift.dates || []).map((date) => date.format && date.format('YYYY-MM-DD')),
			department_id: parseInt(getState().supervisorShift.departmentID),
			has_covid_patients: getState().supervisorShift.hasCovidPatients,
			location_id: parseInt(getState().supervisorShift.locationID),
			nurse_role: getState().supervisorShift.shiftRoles,
			// 07:00:00
			open_positions: parseInt(getState().supervisorShift.openPositions),
			organization_id: parseInt(getState().supervisorShift.organizationID),
			pool_id: getState().supervisorShift.preferredPools,
			prn_pool_duration_in_days: parseInt(getState().supervisorShift.prnPoolDays)
				? parseInt(getState().supervisorShift.prnPoolDays)
				: null,
			prn_pool_enabled: getState().supervisorShift.prnPoolEnabled,
			shift_date: shift_start_date,
			// 07:00:00
			shift_end,
			shift_end_date,
			shift_notes: getState().supervisorShift.shiftNote,
			shift_start
		};

		const { bonusAmount, bonusUnit } = getState().supervisorShift;
		if (bonusAmount > 0 && bonusUnit) {
			shiftObj.bonus_amount = bonusAmount;
			shiftObj.bonus_unit = bonusUnit;
			shiftObj.is_bonus_billable = true;
		}

		dispatch(setIsSuccessful(null));
		dispatch(setIsSubmittingShift(true));

		const appState = getState();
		Agent.createNewShift(shiftObj).then((response) => {
			dispatch(setIsSubmittingShift(false));

			if (response.ok) {
				trackNewShift(shiftObj, appState);
				dispatch(setIsSuccessful(true));
				if (cb) {
					cb(response);
				} else {
					dispatch(resetShift());
					history.push('/supervisor/dashboard');
				}
			} else if (!response.ok && response.status == HTTPStatusCodes.FORBIDDEN) {
				dispatch(setIsForbiddenToCreateShift(true));
				dispatch(setForbiddenMessage(response.data));
				dispatch(setIsSuccessful(false));
			} else {
				alert(response.data);
				dispatch(setIsSuccessful(false));
				dispatch(handleError(response));
			}
		});
	};

function trackNewShift(shiftObj, appState) {
	const supervisorDashboard = appState.supervisordashboard;

	const organizationTitle = supervisorDashboard.organizations.title;
	const { roles, locations } = supervisorDashboard;

	const location = locations.filter((l) => l.location_id == shiftObj.location_id)[0];
	const roleStr = roles
		.filter((r) => shiftObj.nurse_role.includes(r.id))
		.map((r) => r.name)
		.join(',');

	const shift = {
		allowExternalNurses: shiftObj.allow_external_nurses,
		allowFullTimeNurses: shiftObj.allow_full_time_nurses,
		allowPartTimeNurses: shiftObj.allow_part_time_nurses,
		externalNotifyAfterHr: shiftObj.externalNotifyAfterHr,
		fullTimeNotifyAfterHr: shiftObj.fullTimeNotifyAfterHr,
		location: location.location_name,
		nurseRole: roleStr,
		organization: organizationTitle,
		partTimeNotifyAfterHr: shiftObj.partTimeNotifyAfterHr,
		prnPoolDays: shiftObj.prnPoolDays,
		prnPoolEnabled: shiftObj.prnPoolEnabled,
		shiftDates: shiftObj.shift_dates,
		shiftEnd: shiftObj.shift_end,
		shiftEndDate: shiftObj.shift_end_date,
		shiftNotes: shiftObj.shift_notes,
		shiftStart: shiftObj.shift_start,
		shiftStartDate: shiftObj.shift_date,
		shiftTimeList: shiftObj.shift_time_list || null
	};

	mixpanel.track(mixpanelConstants.ADD_NEW_SHIFT, shift);
}

export const setMultipleShiftTimes = (timeID = null) =>
	function (dispatch, getState) {
		const currentSelectedTimeID = [...getState().supervisorShift.selectedShiftTimeList];

		if (timeID) {
			const checkIfRepeated = currentSelectedTimeID.findIndex((time) => time === timeID);
			if (checkIfRepeated !== -1) {
				currentSelectedTimeID.splice(checkIfRepeated, 1);
			} else {
				currentSelectedTimeID.push(timeID);
			}
		}
		dispatch(setSelectedShiftTimeList(currentSelectedTimeID));
	};

export const postMultiTimeShifts = (cb, shift_type) =>
	function (dispatch, getState) {
		const timeIDList = getState().supervisorShift.selectedShiftTimeList;
		const timeList = getState().supervisorShift.shiftTimeList;
		let shiftTimeList = [];

		const { customShiftStartTime } = getState().supervisorShift;
		const { customShiftEndTime } = getState().supervisorShift;
		/* Get selected times from predefined list */
		let start_time;
		let end_time;
		if (timeIDList.length > 0) {
			shiftTimeList = timeIDList.map((timeID) => {
				start_time = _.where(timeList, { id: timeID })[0].start_time;
				end_time = _.where(timeList, { id: timeID })[0].end_time;
				return { end_time, start_time };
			});
		}

		/* Get custom time */
		if (customShiftStartTime && customShiftEndTime) {
			start_time = moment(customShiftStartTime).format('HH:mm:00');
			end_time = moment(customShiftEndTime).format('HH:mm:00');
			shiftTimeList.push({ end_time, start_time });
		}

		const shift_dates = (getState().supervisorShift.dates || []).map(
			(date) => date.format && date.format('YYYY-MM-DD')
		);

		const shiftObj = {
			aft_delay: parseInt(getState().supervisorShift.fullTimeNotifyAfterHr),
			allow_external_nurses: getState().supervisorShift.is_externalNotifyAfter == true ? 'Y' : 'N',
			allow_full_time_nurses: getState().supervisorShift.is_fullTimeNotifyAfter == true ? 'Y' : 'N',
			allow_part_time_nurses: getState().supervisorShift.is_partTimeNotifyAfter == true ? 'Y' : 'N',
			aoa_delay: parseInt(getState().supervisorShift.externalNotifyAfterHr),
			apt_delay: parseInt(getState().supervisorShift.partTimeNotifyAfterHr),
			covid_contact_flag: getState().supervisorShift.covidContactFlag,
			department_id: parseInt(getState().supervisorShift.departmentID),
			has_covid_patients: getState().supervisorShift.hasCovidPatients,
			location_id: parseInt(getState().supervisorShift.locationID),
			nurse_role: getState().supervisorShift.shiftRoles,
			open_positions: parseInt(getState().supervisorShift.openPositions),
			organization_id: parseInt(getState().supervisorShift.organizationID),
			pool_id: getState().supervisorShift.preferredPools,
			prn_pool_duration_in_days: parseInt(getState().supervisorShift.prnPoolDays)
				? parseInt(getState().supervisorShift.prnPoolDays)
				: null,
			prn_pool_enabled: getState().supervisorShift.prnPoolEnabled,
			shift_dates,
			shift_end_date: '',
			shift_notes: getState().supervisorShift.shiftNote,
			shift_time_list: shiftTimeList,
			shift_type
		};

		const { bonusAmount, bonusUnit } = getState().supervisorShift;
		if (bonusAmount > 0 && bonusUnit) {
			shiftObj.bonus_amount = bonusAmount;
			shiftObj.bonus_unit = bonusUnit;
			shiftObj.is_bonus_billable = true;
		}

		dispatch(setIsSuccessful(null));
		dispatch(setIsSubmittingShift(true));

		const appState = getState();
		Agent.createMultiTimeShifts(shiftObj).then((response) => {
			dispatch(setIsSubmittingShift(false));

			if (response.ok) {
				trackNewShift(shiftObj, appState);
				dispatch(setIsSuccessful(true));
				if (cb) {
					cb(response);
				} else {
					dispatch(resetShift());
					history.push('/supervisor/dashboard');
				}
			} else if (!response.ok && response.status == HTTPStatusCodes.FORBIDDEN) {
				dispatch(setIsForbiddenToCreateShift(true));
				dispatch(setForbiddenMessage(response.data));
				dispatch(setIsSuccessful(false));
			} else {
				const message = response.data.message || response.data;
				const status = response.data ? response.data.status : response.status;
				alert(message);
				dispatch(setIsSuccessful(false));
				dispatch(handleError({ ...response, status }));
			}
		});
	};
